import {
  AndJoint,
  Criteria,
  EqFilter,
  Expression,
  Filter,
  ICriteriaTranslator,
  IdsFilter,
  InFilter,
  Joint,
  KeywordFilter,
  LikeFilter,
  OrJoint,
  Pageable,
  QuickFilter,
  Sort,
} from 'slipstream-components';

export default class SDTranslator implements ICriteriaTranslator {
  public translateJointToPost(joint: Joint) {
    const jointKey = joint instanceof AndJoint ? 'and' : 'or';
    const filterPart = {};
    const filterItems = [];
    filterPart[jointKey] = filterItems;
    joint.filters.forEach((filter: Filter) => {
      if (filter instanceof Joint) {
        filterItems.push(this.translateJointToPost(filter));
      } else {
        const expression = filter as Expression;
        filterItems.push(this.translateExpressionToPost(expression));
      }
    });
    return filterPart;
  }
  public translateExpressionToPost(exp: Expression) {
    if (exp instanceof EqFilter) {
      const term = {
        filter: {
          key: exp.field,
          operator: 'EQUALS',
          value: exp.value,
        },
      };
      return term;
    } else if (exp instanceof InFilter) {
      const term = {
        filter: {
          key: exp.field,
          operator: 'EQUALS',
          value: exp.value,
        },
      };
      return term;
    }
    throw new Error('Method not implemented.');
  }
  public translateSortToPost(sort: Sort) {
    // it seems SD only support single sort.
    const order = sort.orders[0];
    return {
      order: order.direction === 'ascend' ? 'ascending' : 'descending',
      sort: order.field,
    };
  }
  public translatePageableToPost(pageable: Pageable) {
    return {
      from: (pageable.page - 1) * pageable.size,
      size: pageable.size,
    };
  }
  public translateJointToGet(joint: Joint): string | string[] {
    let specialFilterStr = null;
    if (joint instanceof AndJoint) {
      const children = joint.getFilters();
      const searchValues = [];
      children.map(f => {
        if (f instanceof KeywordFilter) {
          searchValues.push((f as KeywordFilter).value);
        }
      });
      if (searchValues.length > 0) {
        specialFilterStr =
          '_search=' +
          (searchValues.length > 1
            ? '(' + searchValues.join('+and+') + ')'
            : searchValues[0] + '*');
      }

      // const idsFilter = children.find(f => f instanceof IdsFilter);
      // if (idsFilter) {
      //   if (specialFilterStr != null) {
      //     specialFilterStr += '&';
      //   } else {
      //     specialFilterStr = '';
      //   }
      //   specialFilterStr += 'obj_uuids=' + ((idsFilter as IdsFilter).value as string[]).join(',');
      // }
    }
    let jointStr = null;
    if (joint instanceof AndJoint) {
      jointStr = 'and';
    } else {
      jointStr = 'or';
    }
    const filterStrs = joint.filters
      .filter(f => !(f instanceof KeywordFilter || f instanceof IdsFilter))
      .map(f => {
        if (f instanceof Joint) {
          return this.translateJointToGet(f);
        } else {
          return this.translateExpressionToGet(f as Expression);
        }
      });
    let jointResult;
    if (filterStrs.length > 0) {
      jointResult =
        filterStrs.length === 1 ? filterStrs[0] : '(' + filterStrs.join(' ' + jointStr + ' ') + ')';
    }
    return specialFilterStr ? [specialFilterStr, jointResult] : jointResult;
  }
  public translateExpressionToGet(expression: Expression) {
    if (expression instanceof EqFilter) {
      if (expression.not) {
        return '(' + expression.field + " ne '" + expression.value + "'" + ')';
      } else {
        return '(' + expression.field + " eq '" + expression.value + "'" + ')';
      }
    } else if (expression instanceof LikeFilter) {
      return '(' + expression.field + " contains '" + expression.value + "')";
    } else if (expression instanceof QuickFilter) {
      return;
    }
    throw new Error('Method not implemented.');
  }
  public translateSortToGet(sort: Sort) {
    const order = sort.orders[0];
    return `sortby=(${order.field}(${order.direction === 'ascend' ? 'ascending' : 'descending'}))`;
  }
  public translatePageableToGet(pagable: import('slipstream-components').Pageable) {
    const pStr = `paging=(start eq ${(pagable.page - 1) * pagable.size},limit eq ${pagable.size})`;
    return pStr;
  }
  public translateToPost(c: Criteria) {
    let filterPart = null;
    const filter = c.filter;
    if (c.filter) {
      filterPart = {
        filters:
          filter instanceof AndJoint || filter instanceof OrJoint
            ? this.translateJointToPost(filter)
            : this.translateExpressionToPost(filter as Expression),
      };
    } else {
      filterPart = {};
    }

    if (c.pageable) {
      Object.assign(filterPart, this.translatePageableToPost(c.pageable));
    }
    if (c.sort) {
      Object.assign(filterPart, this.translateSortToPost(c.sort));
    }

    filterPart.detail = true;
    return filterPart;
  }
  public translateToGet(c: Criteria): string {
    const urls = [];
    if (c.pageable) {
      urls.push(this.translatePageableToGet(c.pageable));
    }
    if (c.sort) {
      urls.push(this.translateSortToGet(c.sort));
    }
    if (c.filter) {
      if (c.filter instanceof Joint) {
        const jointResult = this.translateJointToGet(c.filter);
        // array means containing special filter.
        if (jointResult instanceof Array) {
          urls.push(jointResult[0]);
          if (jointResult[1]) {
            urls.push('filter=' + jointResult[1]);
          }
        } else {
          urls.push('filter=' + jointResult);
        }
        // urls = urls.concat(jointResult);
      } else {
        if (c.filter instanceof KeywordFilter) {
          urls.push('_search=' + c.filter.value);
        } else {
          urls.push('filter=(' + this.translateExpressionToGet(c.filter as Expression) + ')');
        }
      }
    }
    return urls.join('&');
  }
}
